import {FC} from 'react';

import {Box, Stack, Typography} from '@mui/material';
import {Link} from 'react-router-dom';

const NotFoundError: FC = () => {
  return (
    <Box
      sx={{
        width: 'calc(100% - 32px)',
        height: 'calc(100% - 64px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack direction="column" spacing={4} sx={{alignItems: 'center'}}>
        <Stack direction="column" sx={{textAlign: 'center'}} spacing={3}>
          <Typography variant="h6">Извините, ничего не найдено</Typography>
          <Typography variant="h4">404</Typography>
        </Stack>
        <Link to="/">
          <Typography variant="h6">Вернуться на главную</Typography>
        </Link>
      </Stack>
    </Box>
  );
};

export default NotFoundError;
